// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import ConfirmModalRedux from './confirm_modal_redux';

export default ConfirmModalRedux;
